import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c2ac344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "building-details" }
const _hoisted_2 = { style: {"display":"inline-block"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "block-number"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Belangrijke data", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Informatie over uw bouwnummer", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  href: "https://www.woningborg.nl/het-certificaat",
  target: "_blank"
}

import { computed } from 'vue'
import { ls } from '@/ls'
import { useRouter } from 'vue-router'
import { ThunderboltFilled, ExportOutlined } from '@ant-design/icons-vue'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingDetails',
  setup(__props) {

const router = useRouter()
const building = computed(() => ls.get('building'))
const buildingCount = computed(() => ls.get('buildings').length)

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "no-mb",
    style: {"background":"white"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle({ width: '100%', height: '240px', backgroundImage: `url('${_unref(building).projectBanner ? _unref(building).projectBanner.url : '/img/logos/Empty_Project_Banner.png'}')`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' })
      }, null, 4),
      _createElementVNode("div", {
        class: "project-logo",
        style: _normalizeStyle({ backgroundColor: 'white', backgroundImage: `url('${_unref(building).projectLogo ? _unref(building).projectLogo.url : '/img/logos/Woonon_Square_Logo.png'}')` })
      }, null, 4),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_2, [
                  _createTextVNode("Bouwnummer " + _toDisplayString(_unref(building).number) + " ", 1),
                  (_unref(building).external_number)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(building).external_number) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                (_unref(buildingCount) > 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      class: "switch-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'BuildingSelector' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Wisselen van bouwnummer")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(building).building_block_number)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Blok " + _toDisplayString(_unref(building).building_block_number), 1))
                  : _createCommentVNode("", true),
                _hoisted_5,
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 10 }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Sluitingsdatum modulair:"),
                        _hoisted_6,
                        _createTextVNode(" Sluitingsdatum ruwbouw:"),
                        _hoisted_7,
                        _createTextVNode(" Sluitingsdatum afbouw:"),
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(building).end_modular ? new Date(_unref(building).end_modular).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1),
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_unref(building).end_carcass ? new Date(_unref(building).end_carcass).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1),
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(_unref(building).end_completion ? new Date(_unref(building).end_completion).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { class: "no-mb" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        (_unref(building).unity_enabled && _unref(building).model_available)
                          ? (_openBlock(), _createBlock(UnityWidget, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 10 }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Projectnaam:"),
                        _hoisted_13,
                        _createTextVNode(" Uw nieuwe adres:"),
                        _hoisted_14,
                        _createTextVNode(" EAN-code energieaansluiting:"),
                        _hoisted_15,
                        _createTextVNode(" Planregistratienummer Woningborg:"),
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(building).project_name ? _unref(building).project_name : '-'), 1),
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_unref(building).address && _unref(building).zipcode && _unref(building).city ? `${_unref(building).address}, ${_unref(building).zipcode} ${_unref(building).city}` : '-'), 1),
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_unref(building).ean_power ? _unref(building).ean_power : '-') + " ", 1),
                        (_unref(building)?.ean_power)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 0,
                              placement: "bottomRight"
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode("Klik voor energie aanbiedingen.")
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  size: "small",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'EnergyComparison', query: { gas_available: 0 } })))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ThunderboltFilled))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_unref(building).certificate ? _unref(building).certificate : '-') + " ", 1),
                        _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
                          title: _withCtx(() => [
                            _createTextVNode("Naar Woningborg")
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_20, [
                              _createVNode(_unref(ExportOutlined))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})